import React from "react";
import styles from "./LeftSideTextField.module.css"
import {openPopupModal, PopupModalName} from "../popupModalProvider/popupModalSlice";
import {useAppDispatch} from "../../../app/hooks";

interface TextFieldProps {
    title: string
    value: any
}

export const LeftSideTextField: React.FC<TextFieldProps> = ({
                                                                title,
                                                                value
                                                            }) => {

    const dispatch = useAppDispatch()

    const MAX_VALUE_LENGTH = 700
    const isViewMore = typeof value === "string" && value.length > MAX_VALUE_LENGTH;
    const preparedValue = isViewMore ? `${value.substring(0, MAX_VALUE_LENGTH)}...` : value ?? "—";

    const handleViewMore = () => {
        dispatch(openPopupModal({
            name: PopupModalName.VIEW_MORE,
            popupModalProps: {
                title,
                value
            }
        }))
    }

    return <div className={styles.wrapper}>
        <span className={styles.title}>{title}</span>
        <div className={styles.valueWrapper}>
            <span className={styles.value}>{preparedValue}</span>
            {isViewMore && <span className={styles.viewMore} onClick={handleViewMore}>View more</span>}
        </div>
    </div>
}
